import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../user/user.service';
import {MenuItem} from '../menu-item';
import {environment} from '../../../environments/environment';
import {Router} from '@angular/router';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent implements OnInit {

  @Input() active;
  public menuItems: Array<MenuItem>;

  constructor(public router: Router, public user: UserService) {
    this.menuItems = [];
  }

  ngOnInit() {
    this.fetchMenuItems();
  }

  // noinspection DuplicatedCode
  fetchMenuItems() {
    this.menuItems = [];
    if(localStorage.getItem('menu') !== null) {
      this.menuItems.push(...JSON.parse(localStorage.getItem('menu')));
    }
    else {
      this.user.modules().then(modules => {
        for(const menuItem of environment.menuItems) {
          if(menuItem.hasOwnProperty('module')) {
            if(modules.includes(menuItem.module)) {
              this.menuItems.push(menuItem);
            }
          }
          else {
            this.menuItems.push(menuItem);
          }
        }
        localStorage.setItem('menu', JSON.stringify(this.menuItems));
      }).catch(() => {
        localStorage.clear();
        this.router.navigate(['/login']);
      });
    }
  }
}
